function validateUniqueId(uid: string, existingIds: Array<string>) {
  if (existingIds.includes(uid) === false) {
    return true;
  }
  return false;
}

export default validateUniqueId;
